import { render } from "./PageLogin.vue?vue&type=template&id=1ed7b20d&scoped=true"
import script from "./PageLogin.vue?vue&type=script&lang=js"
export * from "./PageLogin.vue?vue&type=script&lang=js"

import "./PageLogin.vue?vue&type=style&index=0&id=1ed7b20d&scoped=true&lang=css"

import exportComponent from "F:\\Project Coustomer\\vue film\\film\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed7b20d"]])

export default __exports__